// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Ikr9Jg5tA19F3o {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  flex: 0 0 24px;\n  border-radius: 48px;\n  box-sizing: border-box;\n  border: 1px solid #DFE1E6;\n}\n.Ikr9Jg5tA19F3o a {\n  line-height: 16px;\n}\n._1Vn1BJ15J8FSpS {\n  background-color: #EDDBF4;\n}\n._1Vn1BJ15J8FSpS svg {\n  color: #89609E;\n}\n._3YT0F_qXKOEtQs:hover {\n  background-color: #FFFFFF;\n  cursor: pointer;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notificationIcon": "Ikr9Jg5tA19F3o",
	"supplementNotificationIcon": "_1Vn1BJ15J8FSpS",
	"notificationIconLink": "_3YT0F_qXKOEtQs"
};
export default ___CSS_LOADER_EXPORT___;
